import { CloseAccount } from "@/features/account/close-account";

export const Route = createFileRoute({
  component: CloseAccount,
});
